import React from 'react';
import { APP_TITLE } from '../../constants';
import styles from './index.module.css';

const Logo = () => {
  return (<div className={styles.logo}>{APP_TITLE}</div>);
}

export default Logo;